import { render, staticRenderFns } from "./PopoverCopyToClipboard.vue?vue&type=template&id=9cd63810&scoped=true"
import script from "./PopoverCopyToClipboard.vue?vue&type=script&lang=js"
export * from "./PopoverCopyToClipboard.vue?vue&type=script&lang=js"
import style0 from "./PopoverCopyToClipboard.vue?vue&type=style&index=0&id=9cd63810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd63810",
  null
  
)

export default component.exports